import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/views/homePage/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
  },
  //介绍和详情
  {
    path: "/homedetails",
    name: "HomeDetails",
    component: () => import("@/views/homedetails/index.vue"),
  },
  //帮助文档
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/homedetails/help.vue"),
  },
  //帮助文档详情
  {
    path: "/helpdetails",
    name: "HelpDetails",
    component: () => import("@/views/homedetails/helpdetails.vue"),
  },
  // 社区
  {
    path: "/partner",
    name: "Partner",
    component: () => import("@/views/community/partner.vue"),
  },
  // 申请社区
  {
    path: "/apply",
    name: "Apply",
    component: () => import("@/views/community/apply.vue"),
  },
  // 话题详情
  {
    path: "/topicDetails",
    name: "TopicDetails",
    component: () => import("@/views/community/TopicDetails.vue"),
  },
  // 邀请好友
  {
    path: "/invite",
    name: "Invite",
    component: () => import("@/views/invite/index.vue"),
  },
  // 邀请记录
  {
    path: "/team",
    name: "Team",
    component: () => import("@/views/invite/team.vue"),
  },
  // 发布
  {
    path: "/release",
    name: "Release",
    component: () => import("@/views/release/index.vue"),
  },
  // 资产列表
  {
    path: "/property",
    name: "Property",
    component: () => import("@/views/property/index.vue"),
  },
  // 我的认购
  {
    path: "/mybuy",
    name: "Property",
    component: () => import("@/views/property/mybuy.vue"),
  },
  // 新项目预约
  {
    path: "/propertyDetails",
    name: "PropertyDetails",
    component: () => import("@/views/propertyDetails/index.vue"),
  },
  // 我的社区
  {
    path: "/mycommuntiy",
    name: "Mycommuntiy",
    component: () => import("@/views/community/mycommuntiy.vue"),
  },
  {
    // 错误页面
    path: "*",
    component: () => import("@/views/404.vue"),
  },
  // 资产记录
  {
    path: "/propertyrecord",
    name: "PropertyRecord",
    component: () => import("@/views/property/record.vue"),
  },

  // 运作方式
  {
    path: "/operation",
    name: "operation",
    component: () => import("@/views/operation/operation.vue"),
  },
  {
    path: "/propertybalancd",
    name: "propertyBalancd",
    component: () => import("@/views/property/propertybalancd.vue"),
  },
  // 项目
  {
    path: "/project",
    name: "Project",
    component: () => import("@/views/project/index.vue"),
  },
  // 项目详情
  {
    path: "/projectdetail",
    name: "ProjectDetail",
    component: () => import("@/views/project/detail.vue"),
  },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

//前置守卫(guard)
router.beforeEach((to, from, next) => {
  document.title = process.env.VUE_APP_PROJECT_NAME || "";
  const isAuthenticated = !!sessionStorage.getItem("token");
  // 白名单路径
  const whiteList = ["/login"];

  // 已登录状态访问登录页时重定向到首页
  // if (isAuthenticated && to.path === "/login") {
  //   return next({ name: "HomePage" });
  // }

  // //     // 未登录且不在白名单时跳转登录
  // if (!isAuthenticated && !whiteList.includes(to.path)) {
  //   return next({
  //     path: "/login",
  //     // query: { redirect: to.fullPath } // 携带跳转来源路径
  //   });
  // }

  next();
});

export default router;
